/**
 * View for creating a transformation action as part of the action item creation wizard
 */
define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "./template/transformationActionItemTemplate.html",
  "modules/typeahead/typeaheadModel",
], function ($, Marionette, Messenger, TransformationActionItemTemplate, TypeaheadModel) {
  "use strict";

  const TransformationActionItemView = {};

  TransformationActionItemView.transformationActionItemView = Marionette.ItemView.extend({
    template: TransformationActionItemTemplate,
    triggers: {
      "click #btnSetComplex": "toggle:complex:expression",
    },
    showComplexExpression: function () {
      this.$el.find("#advanceControls").show();
      this.$el.find("#btnSetComplex").text($.t("actions.items.transformation.removeComplex"));
    },
    hideComplexExpression: function () {
      this.$el.find("#advanceControls").hide();
      this.$el.find("#btnSetComplex").text($.t("actions.items.transformation.setComplex"));
    },
    getConversationVariable: function () {
      return this.$el.find("#convVariable").val();
    },
    getExpression: function () {
      return this.$el.find("#expression").val();
    },
    getOperator: function () {
      return this.$el.find("#expOperator").val();
    },
    getSecondExpression: function () {
      return this.$el.find("#secondExpression").val();
    },
    variableError: function (errorMessage) {
      this.$el
        .find("#variableError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    expressionError: function (errorMessage) {
      this.$el
        .find("#expressionError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    secondExpressionError: function (errorMessage) {
      this.$el
        .find("#secondExpressionError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("#variableError").html("");
      this.$el.find("#expressionError").html("");
      this.$el.find("#secondExpressionError").html("");
    },
    onRender: function () {
      this.$el.i18n();
      //set up source function to get the conversation variables for the typeahead data
      const _this = this;
      const sourceFunction = function (query, process) {
        const results = Messenger.reqres.request("action:variables");
        const variableArr = [];
        //get the variable names and build an array for the typeahead to process
        results.forEach(function (convVariable) {
          variableArr.push(convVariable.get("name"));
        });
        process(variableArr);
      };

      this.$el.find("#convVariable").typeahead({
        source: sourceFunction,
        updater: function (item) {
          //set the value of the textbox
          _this.$el.find("#convVariable").val(item);
          return item;
        },
      });

      this.$el.find("#expression").typeahead({
        source: sourceFunction,
        updater: function (item) {
          //set the value of the textbox
          _this.$el.find("#expression").val(item);
          return item;
        },
      });

      this.$el.find("#secondExpression").typeahead({
        source: sourceFunction,
        updater: function (item) {
          //set the value of the textbox
          _this.$el.find("#secondExpression").val(item);
          return item;
        },
      });
    },
  });

  return TransformationActionItemView;
});
